import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { ToastrService } from 'ngx-toastr';
import { UserService } from '../../services/api-services/user.service';

@Component({
  selector: 'app-upload-fax-detail',
  templateUrl: './upload-fax-detail.component.html',
  styleUrl: './upload-fax-detail.component.scss'
})
export class UploadFaxDetailComponent implements OnInit {
  progress_spinner: boolean = true;
  details: any;
  DrugList: any[] = [];
  dataFound: boolean = true;
  constructor(
    public dialogRef: MatDialogRef<UploadFaxDetailComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    public toastr: ToastrService,
    public userService: UserService
  ) { }

  ngOnInit() {
    this.getViewFaxPrescription();
  }

  getViewFaxPrescription() {
    this.progress_spinner = true;
    this.dataFound = true;
    const payload = {
      "message_id": this.data?.item?.rc_message_id

    }
    this.userService.view_fax_detail(payload).subscribe({
      next: (res) => {
        if (res?.body?.success) {
          this.details = res?.body?.data || {};
          this.DrugList = res?.body?.data?.drugs_ai || [];
          this.progress_spinner = false;
        } else {
          this.progress_spinner = false;
          this.dataFound = false;
        }
      },
      error: (err) => {
        console.error("error::", err);
        this.toastr.error(err.error);
        this.progress_spinner = false;
        this.dataFound = false;
      }
    })
  }

  openPdf(details: any) {
    if (details.azure_file_path) {
      window.open(details.azure_file_path, '_blank')
    } else {
      this.toastr.error('PDF file not available');
    }
  }

}
